import { ErrorTemplate } from "UIComponents";
import { ThemeType, UIThemeProvider } from "UIShared";
import { Button, Text } from "UIComponents";
import { useForbiddenWithLogoutController } from "./controller";

export function ForbiddenWithLogout() {
  const { logOut } = useForbiddenWithLogoutController();
  return (
    <UIThemeProvider type={ThemeType.SYSTEM}>
      <ErrorTemplate
        title="Forbidden"
        description="You don't have permit to access this verification. Try relogin with another email"
        code={403}
      >
        <Button onClick={logOut}>Go to logout</Button>
        <Text
          text={`If any problems please contact support - ${
            process.env.REACT_APP_CONTACT_SUPPORT || "support@arival.com"
          }`}
          size={14}
          weight="Light"
          color="primary-text-color"
        />
      </ErrorTemplate>
    </UIThemeProvider>
  );
}
